import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export enum TypeEnum {
  warning = 'warning',
  success = 'success',
  error = 'error',
}

export interface IMessage {
  text: string;
  type: TypeEnum;
}

interface ICommonState {
  isLoading: boolean;
  message?: IMessage;
}

const initialState: ICommonState = {
  isLoading: false,
  message: undefined,
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      return state;
    },
    setMessage: (state, action: PayloadAction<IMessage | undefined>) => {
      state.message = action.payload;
      return state;
    },
  },
});
